import React, { useEffect, useMemo, useState } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { MAP_FALLBACK_CENTER, pointPosition } from "components/RoutePlot";

const ReportFleetMap = ({ fleetInfo, overlayImg }) => {
  const [mapData, setMapData] = useState([]);
  const [assetImg, setAssetImg] = useState("");
  const carWidth = 30;
  const carHeight = 50;

  useEffect(() => {
    setMapData(fleetInfo);
    setAssetImg(overlayImg);
  }, [fleetInfo, overlayImg]);

  const mapContainerStyle = {
    height: "500px",
    width: "100%",
  };

  const placed = useMemo(
    () => (mapData || []).map((point) => ({ point, position: pointPosition(point) })).filter((item) => item.position),
    [mapData]
  );
  const center = placed[0]?.position || MAP_FALLBACK_CENTER;

 

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      {" "}
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={15}
      >

        {placed.map(({ point, position }, index) => {
          return window.google ? (
            <Marker
              key={index}
              position={position}
              icon={{
                url: assetImg,
                scaledSize: new window.google.maps.Size(carWidth, carHeight),
                rotation: point.dirn,
              }}
              label={{
                color: "black",
                fontSize: "12px",
              }}
            />
          ) : null;
        })}
      </GoogleMap>
    </LoadScript>
  );
};

export default ReportFleetMap;
